import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Register necessary components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// Line Chart Component
const LineChart = ({ dataArray, xKey, yKeys, labels, bgcolors, borderColors, yLableRoatation, pointbgColors, tooltipType = 'normal', legendPosition = 'top', showLegend = true, showLegendTitle = true, legendTitleText = 'Example title'  }) => {
  // Extracting the data for the chart

  const labelsData = dataArray.map(item => item[xKey]);
//   const labels = dataArray.map(item => item.duration);
//   const netCashFlowData = dataArray.map(item => parseFloat(item.cashflow));
//   const netBizCashFlowData = dataArray.map(item => parseFloat(item.bizCashFlow));


const datasets = yKeys.map((yKey, index) => ({
    label: labels[index],
    data: dataArray.map(item => parseFloat(item[yKey])),
    borderColor: borderColors[index],
    backgroundColor: bgcolors[index],
    pointBackgroundColor: pointbgColors[index],
    pointBorderColor: '#fff', // Point border color
    pointBorderWidth: 2,
    pointRadius: 5, // Point size
    borderWidth: 2,
    tension: 0, // Curve of the line (smoother)
  }));


  // Define the data for the line chart
  const data = {
    labels: labelsData, // X-axis labels (months)
    datasets: datasets,
  };

  // Define chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: showLegend,
        position: legendPosition,
        labels: {
          usePointStyle: true, // Use point style similar to your image
        },
      },
      title: {
        display: showLegendTitle,
        text: legendTitleText,
        font: {
          size: 16,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let value = context.raw || 0;
            if (tooltipType === 'currency') {
                return `₹: ${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`; // Format in INR
            }
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Hide vertical grid lines
        },
        ticks: {
            maxRotation: yLableRoatation,
            minRotation: yLableRoatation,
        },
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.1)', // Light gray grid lines
          borderDash: [5, 5], // Dotted grid lines for y-axis
        },
      },
    },
  };

  return (
    <div>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
